

module.exports = {
    updateAttribute: function () {
        $("body").on("product:afterAttributeSelect", function (e, response) {
            if (response.data && response.data.product !== undefined) {
                response.container.find(".eretailers_details").empty().html(response.data.product.renderedRetailer);
            }
        });
    }
};
